module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vrassets/_next/static/images/flap-99fdb09373ce99b548e9fe32c46d8842.png";